import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import {loadings} from "../../store/store";
import {useMainTranslation} from "../../../../../newShared/hooks/useMainTranslationHooks/useMainTranslation";
import {useSetBreadcrumbs} from "../../../../barsEnvironment/breadcrumbs/hooks/useBreadcrumbs";
import {PATH_LOCAL_ASSET_MANAGEMENT} from "../../../../../newShared/constants";
import {
    PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATE_SETTINGS,
    PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATE_SETTINGS_EXACT,
    PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATES
} from "../../constants";
import {TCertificateAssetSettingsId} from "../../types";


export const useCertificateSettings = () => {
    const {t: tMenu} = useMainTranslation('', {keyPrefix: 'LeftMenu'});
    const history = useHistory();
    const {isLoadingSettings} = useSelector(loadings);

    useSetBreadcrumbs([
        {
            title: tMenu('Asset Management'),
            path: PATH_LOCAL_ASSET_MANAGEMENT
        },
        {
            title: tMenu('Certificates'),
            path: PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATES
        },
        {
            title: 'Settings',
            path: PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATE_SETTINGS
        },
    ]);

    const handleGoToSettingById = (id: TCertificateAssetSettingsId) => {
        history.push(PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATE_SETTINGS_EXACT.replace(':id', id));
    }

    const handleGoBack = () => {
        history.push(PATH_LOCAL_ASSET_MANAGEMENT_CERTIFICATES);
    }

    return {
        handleGoBack,
        isLoadingSettings,
        handleGoToSettingById,
    }

}
